import * as React from 'react';
import { useToggleState } from '@cian/react-utils';
import { useSelector } from 'react-redux';

import { VideoPlaybackModal } from '../../components/VideoPlaybackModal';
import { useApplicationContext } from '../../utils/applicationContext';
import { HeroSection } from '../../components/HeroSection';
import { trackNavigateToDealForm } from '../../utils/analytics';
import { trackOpenVideoModalClick } from './tracking';
import { selectDealFormUrl } from '../../selectors/promoInfo/selectDealFormUrl';
import { ConsultationRequestButtonContainer } from '../ConsultationRequestButtonContainer';
import { ERuntimeSettings } from '../../types/runtimeSettings';

/**
 * Первая секция на странице.
 */
export const HeroSectionContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { config } = useApplicationContext();
  const { state: showVideoModalState, toggle: toggleVideoModalState } = useToggleState();
  const dealFormUrl = useSelector(selectDealFormUrl);
  const videoSrc = config.get<string>(ERuntimeSettings.DealProcessVideoIframeUrl) || /* istanbul ignore next */ '';
  const onCreateDealButtonClick = () => {
    trackNavigateToDealForm('main');
  };
  const onAboutDealButtonClick = () => {
    trackOpenVideoModalClick();
    toggleVideoModalState();
  };

  return (
    <>
      <HeroSection
        onAboutDealButtonClick={onAboutDealButtonClick}
        onCreateDealButtonClick={onCreateDealButtonClick}
        videoSrc={videoSrc}
        consultationRequestButton={
          <ConsultationRequestButtonContainer theme="fill_white_secondary">
            Хочу консультацию
          </ConsultationRequestButtonContainer>
        }
        dealFormUrl={dealFormUrl}
        needStopVideo={showVideoModalState}
      />
      <VideoPlaybackModal videoSrc={videoSrc} isOpen={showVideoModalState} onClose={toggleVideoModalState} />
    </>
  );
};

HeroSectionContainer.displayName = 'HeroSectionContainer';
